import type { DayState } from "@/lib/calendarOccupancy";

type Props = {
  state: DayState;
  title: string;
  weekend?: boolean;
};

const FREE = "var(--cal-free)";
const BUSY = "var(--cal-busy)";
const W = 100;
const H = 100;

export function DayCell({ state, title, weekend }: Props) {
  const leftColor = state.morning ? BUSY : FREE;
  const rightColor = state.afternoon ? BUSY : FREE;
  return (
    <svg
      width="100%"
      height="100%"
      viewBox={`0 0 ${W} ${H}`}
      preserveAspectRatio="none"
      style={{ display: "block", outline: weekend ? "1px solid var(--cal-weekend)" : "none" }}
    >
      <title>{title}</title>
      <polygon points={`0,0 ${W},0 0,${H}`} fill={leftColor} />
      <polygon points={`${W},0 ${W},${H} 0,${H}`} fill={rightColor} />
      <line x1={W} y1={0} x2={0} y2={H} stroke="rgba(0,0,0,0.35)" strokeWidth={1.5} vectorEffect="non-scaling-stroke" />
    </svg>
  );
}
